export const CREATE_EDIT_GROUP = 'create-edit-group';
export const DELETE_GROUP = 'delete-group';
export const DELETE_MULTIPLE_GROUPS = 'delete-multiple-groups';
export const MOVE_GROUP_MEMBER = 'move-group-member';
